module.exports = __webpack_public_path__ + "img/plan_3.6a21bbe5.jpg";